import { Dialog, Drawer } from '@backyard-ui/core'

const handleIsOnMobile = () => {
  return window.innerWidth <= 640
}

export const Component = handleIsOnMobile() ? Drawer : Dialog
export const componentType = handleIsOnMobile() ? 'drawer' : 'dialog'
